import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '@reveni-io/reveni-ui'

import { refundHoldModeValues } from '@/common/constants'
import returnsServices from '@/returns/services/services'

import { buildPutRefundOnHoldPayload } from './helpers'
import { transformRequestPutRefundOnHold } from './transformers'

const usePutRefundOnHold = ({ returnId, fetchData, fetchTimeline, setToastInfo }) => {
  const { t } = useTranslation()
  const [showPutRefundOnHoldDrawer, setShowPutRefundOnHoldDrawer] = useState(false)
  const [refundHoldMode, setRefundHoldMode] = useState(refundHoldModeValues.holdIndefinitely)
  const [refundHoldDelayDays, setRefundHoldDelayDays] = useState('')
  const [refundHoldReason, setRefundHoldReason] = useState('')

  const { fetchData: putRefundOnHold, loading: puttingRefundOnHold } = useFetch(returnsServices.putRefundOnHold, {
    doInitialRequest: false,
    transformRequest: transformRequestPutRefundOnHold,
  })

  const openPutRefundOnHoldDrawer = () => {
    setShowPutRefundOnHoldDrawer(true)
  }

  const closePutRefundOnHoldDrawer = () => {
    setShowPutRefundOnHoldDrawer(false)
    setRefundHoldMode(refundHoldModeValues.holdIndefinitely)
    setRefundHoldDelayDays('')
    setRefundHoldReason('')
  }

  const handlePutRefundOnHold = async () => {
    try {
      const payload = buildPutRefundOnHoldPayload({
        mode: refundHoldMode,
        delayDays: refundHoldDelayDays,
        reason: refundHoldReason,
      })
      await putRefundOnHold({ returnId, payload })

      closePutRefundOnHoldDrawer()
      setToastInfo({ show: true, message: t('Reembolso puesto en espera correctamente'), type: 'success' })
      fetchData()
      fetchTimeline()
    } catch (error) {
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  return {
    showPutRefundOnHoldDrawer,
    openPutRefundOnHoldDrawer,
    closePutRefundOnHoldDrawer,
    handlePutRefundOnHold,
    puttingRefundOnHold,
    refundHoldMode,
    setRefundHoldMode,
    refundHoldDelayDays,
    setRefundHoldDelayDays,
    refundHoldReason,
    setRefundHoldReason,
  }
}

export default usePutRefundOnHold
